import { put, takeEvery } from "redux-saga/effects";

function* updateProfileStatus(action) {
    try {
        yield put({
            type: "UPDATE_PROFILE_DATA",
            payload: action.payload,
        });
    } catch (error) {
        console.log("Saga error:", error);
    }
}

export function* _updateProfileStatus() {
    yield takeEvery("UPDATE_PROFILE_DATA", updateProfileStatus);
}
